module.exports = __webpack_public_path__ + "static/media/progress-base.8ec87a4c.png";